import { useState } from "react";
import clsx from "clsx";
import Stripe from "stripe";

import Modal from "components/Modal";
import ContactForm from "elements/Contact-Form";

import { Plan } from "lib/stripe";

import TickMark from "./Tick-Mark";
import BuyButton from "./Buy-Button";
import PriceComponent from "./Price";
import useHandleCheckout from "./checkout";

interface Props {
  plan: Plan;
  prevPlan?: Plan;
  planLength: "monthly" | "annual";
  coupon?: Stripe.Coupon | null;
  location: string;
  onSelect: (planId: string) => unknown;
}

const PlanComponent = ({
  plan,
  prevPlan,
  planLength,
  location,
  onSelect,
  coupon,
}: Props) => {
  const [handleCheckout, priceIdLoading] = useHandleCheckout();
  const [showContact, setShowContact] = useState(false);

  const priceId =
    plan.priceIds?.[location === "India" ? "INR" : "USD"]?.[planLength];
  const price =
    plan.price?.[location === "India" ? "INR" : "USD"]?.[planLength];
  return (
    <div
      className={clsx(
        "w-full p-4 mb-4 md:mb-0 md:px-2 text-center shadow-2xl rounded-2xl",
        plan.default && "relative border-2 border-blue-600 bg-blue-100",
        "flex flex-col",
        "text-center"
      )}
    >
      {plan.default && (
        <div
          className="absolute top-0 right-0 p-3 -mt-5 mr-5"
          style={{
            borderRadius: "9999px",
            backgroundColor: "rgba(236,201,75,1)",
          }}
        >
          <svg
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/svg"
            className="h-4 text-white fill-current"
          >
            <path d="M15.145 5.05l-4.316-.627L8.898.513c-.338-.684-1.456-.684-1.794 0l-1.93 3.91-4.317.627a1.002 1.002 0 00-.554 1.707l3.124 3.044-.737 4.3a1 1 0 001.45 1.053L8 13.125l3.862 2.03c.728.381 1.59-.234 1.45-1.054l-.736-4.299L15.7 6.758a1.003 1.003 0 00-.555-1.708z"></path>
          </svg>
        </div>
      )}
      <p className="text-xl font-bold md:font-semibold md:text-gray-700">
        {plan.name}
      </p>
      <div className={"text-center h-40 inline-flex flex-col align-middle"}>
        {priceId && !isNaN(price) ? (
          <>
            <PriceComponent price={price} location={location} coupon={coupon} />
            <p className="text-base text-center text-gray-600">
              per month{" "}
              {planLength === "annual" && <span>when billed yearly</span>}
            </p>
          </>
        ) : (
          <p className="text-4xl text-center pt-4 px-2 font-semibold">
            Contact Us
          </p>
        )}
        {plan.planConditionText && (
          <p className="text-base text-gray-600">{plan.planConditionText}</p>
        )}
      </div>

      <div
        className="mt-4 pt-4 md:pl-2 md:ml-2 text-left h-auto"
        // style={{ height: "360px" }}
      >
        {prevPlan && (
          <p className="pb-2 font-bold">
            <TickMark /> All {prevPlan.name} features
          </p>
        )}
        <p className="pb-2">
          <TickMark /> {plan.dataSets} data-files
        </p>
        <p className="pb-2">
          <TickMark />{" "}
          <span>
            {typeof plan.maxRows === "number" ? (
              <span>Upto {plan.maxRows.toLocaleString()}</span>
            ) : (
              <span>{plan.maxRows}</span>
            )}{" "}
            rows and {plan.maxCols.toLocaleString()} columns per data-file
          </span>
        </p>

        <p className="pb-2">
          <TickMark />{" "}
          {plan.maxProjects && plan.maxProjects >= 1
            ? `Upto ${plan.maxProjects.toLocaleString()}`
            : "Unlimited"}{" "}
          projects
        </p>
        <p className="pb-2">
          <TickMark /> {plan.hosting}
        </p>
        {plan.features?.map((f) => (
          <p key={f} className="pb-2">
            <TickMark /> {f}
          </p>
        ))}
      </div>

      <div className="pt-4 mt-auto">
        {priceId ? (
          <BuyButton
            priceId={priceId}
            isDefault={plan.default}
            onClick={(priceId) => {
              handleCheckout(priceId);
              onSelect(priceId);
            }}
            loading={priceIdLoading === priceId}
          />
        ) : (
          <>
            <p
              className="btn btn-lg cursor-pointer bg-white border border-brand-600"
              onClick={() => setShowContact(true)}
            >
              Contact Us
            </p>
            <Modal
              id={`contact-us-${plan.name}`}
              show={showContact}
              handleClose={() => setShowContact(false)}
            >
              <ContactForm page={plan.name} />
            </Modal>
          </>
        )}
      </div>
    </div>
  );
};

export default PlanComponent;
